import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { Avatar, Box, ButtonBase, SvgIcon, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import SettingsDrawer from '@/features/settings-drawer/SettingsDrawer'
import useAuth from '@/hooks/useAuth'
import { usePopover } from '@/hooks/usePopover'
import { AccountPopover } from './account-popover'

export const AccountButton = () => {
    const { user, settings } = useAuth()
    const popover = usePopover()
    const [settingsOpen, setSettingsOpen] = useState(false)
    const smUp = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    return (
        <>
            <Box
                component={ButtonBase}
                onClick={popover.handleOpen}
                ref={popover.anchorRef}
                sx={[
                    {
                        alignItems: 'center',
                        display: 'flex',
                        borderWidth: 2,
                        borderStyle: 'solid',
                        borderColor: 'primary.main',
                        borderRadius: settings.style.roundedCorners
                            ? '50%'
                            : '2px'
                    },
                    smUp
                        ? {
                              height: 42
                          }
                        : {
                              height: 34
                          },
                    smUp
                        ? {
                              width: 42
                          }
                        : {
                              width: 34
                          }
                ]}
            >
                <Avatar
                    sx={[
                        {
                            backgroundColor: 'primary.main',
                            color: 'primary.contrastText'
                        },
                        smUp
                            ? {
                                  height: 34
                              }
                            : {
                                  height: 26
                              },
                        smUp
                            ? {
                                  width: 34
                              }
                            : {
                                  width: 26
                              }
                    ]}
                    src={user.avatar_image ? user.avatar_image : user.avatar}
                >
                    <SvgIcon>
                        <ManageAccountsIcon />
                    </SvgIcon>
                </Avatar>
            </Box>
            <AccountPopover
                anchorEl={popover.anchorRef.current}
                onClose={popover.handleClose}
                open={popover.open}
                onDisplayClick={() => {
                    popover.handleClose()
                    setSettingsOpen(true)
                }}
            />
            <SettingsDrawer
                open={settingsOpen}
                onClose={() => setSettingsOpen(false)}
            />
        </>
    )
}
